module.exports = __webpack_public_path__ + "static/img/software9.cdca6bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software9.jpg
// module id = ekfN
// module chunks = 2